import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["type"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/** @jsx jsx */

import React from 'react';
import { jsx } from '@emotion/react';
import { overflowShadow } from '@atlaskit/editor-common/ui';
import { calculateBreakoutStyles } from '@atlaskit/editor-common/utils';
import { wrapperStyle, header, content, contentWrapper, widerLayoutClassName } from './styles';
import { overlay } from '../styles';
import ExtensionLozenge from '../Lozenge';
import classnames from 'classnames';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
function ExtensionWithPluginState(props) {
  var node = props.node,
    handleContentDOMRef = props.handleContentDOMRef,
    children = props.children,
    _props$widthState = props.widthState,
    widthState = _props$widthState === void 0 ? {
      width: 0
    } : _props$widthState,
    handleRef = props.handleRef,
    shadowClassNames = props.shadowClassNames,
    hideFrame = props.hideFrame,
    editorAppearance = props.editorAppearance;
  var hasBody = node.type.name === 'bodiedExtension';
  var isMobile = editorAppearance === 'mobile';
  var hasChildren = !!children;
  var removeBorder = hideFrame && !isMobile && !hasBody || false;
  var getPos = props.getPos,
    view = props.view;
  var isTopLevelNode = React.useMemo(function () {
    try {
      var pos = typeof getPos === 'function' ? getPos() : undefined;
      return typeof pos !== 'undefined' && !isNaN(pos) && view.state.doc.resolve(pos).depth === 0;
    } catch (e) {
      return false;
    }
    return false;
  }, [view, getPos]);
  var shouldBreakout =
  // Extension should breakout when the layout is set to 'full-width' or 'wide'.
  ['full-width', 'wide'].includes(node.attrs.layout) &&
  // Extension breakout state should only be respected for top level nodes.
  isTopLevelNode &&
  // Extension breakout state should not be respected when the editor appearance is full-width mode
  editorAppearance !== 'full-width';
  var classNames = classnames('extension-container', 'block', shadowClassNames, _defineProperty({
    'with-overlay': !hasBody,
    'without-frame': removeBorder
  }, widerLayoutClassName, shouldBreakout));
  var headerClassNames = classnames({
    'with-children': hasChildren,
    'without-frame': removeBorder
  });
  var customContainerStyles = {
    width: '100%'
  };
  var newContentStyles = {};
  if (shouldBreakout) {
    var _calculateBreakoutSty = calculateBreakoutStyles({
        mode: node.attrs.layout,
        widthStateWidth: widthState.width,
        widthStateLineLength: widthState.lineLength
      }),
      type = _calculateBreakoutSty.type,
      breakoutStyles = _objectWithoutProperties(_calculateBreakoutSty, _excluded);
    newContentStyles = _objectSpread({}, breakoutStyles);
    customContainerStyles = breakoutStyles;
  }
  newContentStyles = _objectSpread(_objectSpread({}, newContentStyles), contentWrapper);
  return jsx("div", {
    ref: handleRef,
    "data-layout": node.attrs.layout,
    className: classNames,
    css: wrapperStyle,
    style: customContainerStyles
  }, jsx("div", {
    className: "extension-overflow-wrapper ".concat(hasBody ? 'with-body' : '')
  }, jsx("div", {
    css: overlay,
    className: "extension-overlay"
  }), jsx("div", {
    css: header,
    contentEditable: false,
    className: headerClassNames
  }, !removeBorder && jsx(ExtensionLozenge, {
    node: node
  }), children), hasBody && jsx("div", {
    css: newContentStyles
  }, jsx("div", {
    css: content,
    ref: handleContentDOMRef,
    className: "extension-content block"
  }))));
}
var Extension = function Extension(props) {
  // TODO: ED-17836 This code is here because confluence injects
  // the `editor-referentiality` plugin via `dangerouslyAppendPlugins`
  // which cannot access the `pluginInjectionApi`. When we move
  // Confluence to using presets we can remove this workaround.
  var pluginInjectionApi = props.pluginInjectionApi;
  return pluginInjectionApi === undefined ? jsx(ExtensionDeprecated, props) : jsx(ExtensionWithSharedState, props);
};
var ExtensionWithSharedState = function ExtensionWithSharedState(props) {
  var pluginInjectionApi = props.pluginInjectionApi;
  var _useSharedPluginState = useSharedPluginState(pluginInjectionApi, ['width']),
    widthState = _useSharedPluginState.widthState;
  return jsx(ExtensionWithPluginState, _extends({
    widthState: widthState
  }, props));
};
import { WithPluginState } from '@atlaskit/editor-common/with-plugin-state';
// TODO: ED-17836 This code is here because Confluence injects
// the `editor-referentiality` plugin via `dangerouslyAppendPlugins`
// which cannot access the `pluginInjectionApi`. When we move
// Confluence to using presets we can remove this workaround.
// @ts-ignore
var widthPluginKey = {
  key: 'widthPlugin$',
  getState: function getState(state) {
    return state['widthPlugin$'];
  }
};
var ExtensionDeprecated = function ExtensionDeprecated(props) {
  return jsx(WithPluginState, {
    editorView: props.view,
    plugins: {
      widthState: widthPluginKey
    },
    render: function render(_ref) {
      var widthState = _ref.widthState;
      return jsx(ExtensionWithPluginState, _extends({
        widthState: widthState
      }, props));
    }
  });
};
/**
 * End workaround
 */

export default overflowShadow(Extension, {
  overflowSelector: '.extension-overflow-wrapper'
});